/* ----------------------------------------------------------
Model to have values of all filters applied on main-items screen 
                    before navigation
------------------------------------------------------------*/
export class MainItemsFiltersModel {
    pageNo: number;
    sortDirection: string;
    sortBy: string;
    itemSearch: string;
}